// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import axios from "axios";
import { encryptHeader } from "../utils/encryptHeader";
import { encryptPassword } from "../utils/encryptPassword";
import { clearStorage } from "../utils/clearstore";
import amplitude from "../utils/amplitude/initiate";
import { userLogsAPI } from "./session.service";
import environment from "../config/environment";
const dotenv = require("dotenv");

require("dotenv").config();
const API_ENDPOINT = require("../config/server");
const { getSession, setSession } = require("../utils/sessionstore");

// fake commit
export async function authenticate(payload) {
  const encryptedString = await encryptPassword(payload.password.trim());

  let formattedPayload = {
    Dashboard_Details: {
      Dashboard_Name: "Lobby",
      Dashboard_Version: "V1",
      API_Route: "LOGIN_USER",
      Method: "POST",
    },

    Parameters: {
      data: { email: payload.email.trim(), password: encryptedString },
    },
  };

  const axiosoptions = {
    url: `${API_ENDPOINT}`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      session_id: getSession("session_id"),
      Authorization: `Bearer ${getSession("session_hwai")}`,
      "Accept-Encoding":"identity",
      deviceid: localStorage.getItem("amplitudeDeviceId") ?? null,
      environment: environment,
    },
    data: formattedPayload,
  };

  const response = await axios(axiosoptions);

  return response.data;
}

export async function forgotUserPassword(email) {
  let formattedPayload = {
    Dashboard_Details: {
      Dashboard_Name: "Lobby",
      Dashboard_Version: "V1",
      API_Route: "FORGOT_PASSWORD",
      Method: "POST",
    },

    Parameters: {
      data: {},
    },
  };

  const axiosoptions = {
    url: `${API_ENDPOINT}`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      user: email,
      session_id: getSession("session_id"),
      Authorization: `Bearer ${getSession("session_hwai")}`,
      'Accept-Encoding': 'identity',
      deviceid: localStorage.getItem("amplitudeDeviceId") ?? null,
      environment: environment,
    },
    data: formattedPayload,
    withCrendentials: true,
  };
  const response = await axios(axiosoptions);

  return response.data;
}

export async function resetPassword(payload) {
  const urlPath = window.location.pathname; // Example: "/auth/forgotpassword/67569fc5b2d6a55693ad66dd"
  const sessionId = urlPath.split("/").pop();
  const encryptedString = await encryptPassword(payload.password.trim());

  let formattedPayload = {
    Dashboard_Details: {
      Dashboard_Name: "Lobby",
      Dashboard_Version: "V1",
      API_Route: "RESET_USER_PASSWORD",
      Method: "PATCH",
    },

    Parameters: {
      data: { password: encryptedString },
    },
  };

  // Opened from an emailed link with no session, so there is no per-session
  // key. The server authorises this route from session_id and ignores the token.
  const axiosoptions = {
    url: `${API_ENDPOINT}`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      session_id: sessionId,
      'Accept-Encoding': 'identity',
      deviceid: localStorage.getItem("amplitudeDeviceId") ?? null,
      environment: environment,
    },
    data: formattedPayload,
    withCrendentials: true,
  };
  const response = await axios(axiosoptions);

  return response.data;
}

export async function authenticateTableau() {
  let formattedPayload = {
    Dashboard_Details: {
      Dashboard_Name: "Lobby",
      Dashboard_Version: "V1",
      API_Route: "AUTHENTICATE_TABLEAU",
      Method: "GET",
    },

    Parameters: {
      data: {},
    },
  };
  const { encryptedHeader, iv } = await encryptHeader(getSession("session_hwai"));
  const axiosoptions = {
    url: `${API_ENDPOINT}`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      session_id: getSession("session_id"),
      Authorization: `Bearer ${encryptedHeader}`,
      "IV":iv,
      'Accept-Encoding': 'identity'
    },
    data: formattedPayload,
  };
  const response = await axios(axiosoptions);

  return response.data;
}

export async function getTableauTicket(targetSite, accesstype) {
  try {
    console.log(accesstype, "I am the access type", targetSite, "target site");
    let formattedPayload = {
      Dashboard_Details: {
        Dashboard_Name: "Lobby",
        Dashboard_Version: "V1",
        API_Route: "GET_TABLEAU_TICKET",
        Method: "GET",
      },

      Parameters: {
        target_site: targetSite,
        accesstype: accesstype,
        data: {},
      },
    };

    const { encryptedHeader, iv } = await encryptHeader(getSession("session_hwai"));

    const axiosoptions = {
      url: `${API_ENDPOINT}`,
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        session_id: getSession("session_id"),
        Authorization: `Bearer ${encryptedHeader}`,
        "IV":iv,
        'Accept-Encoding': 'identity'
      },
      data: formattedPayload,
    };
    const response = await axios(axiosoptions);
    console.log(response.data, "reponse.data from getTableauTicket");

    return response.data;
  } catch (err) {
    console.log("ERROR", err);
  }
}

export async function verifySession({ session_id }) {
  let formattedPayload = {
    Dashboard_Details: {
      Dashboard_Name: "Lobby",
      Dashboard_Version: "V1",
      API_Route: "VERIFY_SESSION",
      Method: "POST",
    },

    Parameters: {
      data: {},
    },
  };

  // Also called from the emailed reset-password link, where there is no session
  // yet and so no per-session key to sign with. Fall back to the unencrypted
  // bearer header that the other pre-auth routes here (LOGIN_USER,
  // FORGOT_PASSWORD) send, since the server still expects the header present.
  const token = getSession("session_hwai");
  const auth =
    token && getSession("session_key") ? await encryptHeader(token) : null;

  const axiosoptions = {
    url: `${API_ENDPOINT}`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      session_id: session_id,
      Authorization: `Bearer ${auth ? auth.encryptedHeader : token}`,
      ...(auth ? { IV: auth.iv } : {}),
      'Accept-Encoding': 'identity'
    },
    data: formattedPayload,
    withCrendentials: true,
  };
  const response = await axios(axiosoptions);

  return response.data;
}

export async function logoutUser({ activedashboard, type, token, session_id, userDetails, clientname, client_id, lobbyStartTime, dashboardStartTime, endTime }) {

  // session Id & token added to call this API after logout
  let formattedPayload = {
    Dashboard_Details: {
      Dashboard_Name: "Lobby",
      Dashboard_Version: "V1",
      API_Route: "LOGOUT_SESSION",
      Method: "POST",
    },

    Parameters: {
      data: {},
    },
  };
  const { encryptedHeader, iv } = await encryptHeader(getSession("session_hwai")||token);
  const axiosoptions = {
    url: `${API_ENDPOINT}`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      session_id: getSession("session_id") || session_id,
      Authorization: `Bearer ${encryptedHeader}`,
      "IV": iv,
      'Accept-Encoding': 'identity'
    },
    data: formattedPayload,
    withCrendentials: true,
  };

  if (!getSession("isLoggedOut")) {
    setSession("isAuth", false);
    //AUTH
    await userLogsAPI(
      "AUTH",
      "LOBBY",
      userDetails, // used stored userdetails to call api after logging out when clicked logout
      clientname, // used stored clientname to call api after logging out when clicked logout
      "LOBBY",
      "Viewed",
      client_id, // used stored clientid to call api after logging out when clicked logout
      undefined,
      lobbyStartTime,
      endTime,
      session_id, // used variable of session id to call api after logging out when clicked logout
      token
    )
    //Dashboard
    if (Object.keys(activedashboard).length > 0 && type && dashboardStartTime) {
      await userLogsAPI(
        type,
        activedashboard?.standarddashboardId?.standardName,
        userDetails,
        clientname,
        activedashboard?.dashboardname,
        "Viewed",
        client_id,
        activedashboard?._id,
        dashboardStartTime,
        endTime,
        session_id,
        token
      )
    }

    await axios(axiosoptions);
    // amplitude.setSessionId(-1);
    amplitude.reset();
    clearStorage();
    setSession("isLoggedOut", true);
    setSession("isAuth", false);
    await amplitude.flush().promise;
  }
}
